import GoodsModal from './GoodsModal'
export default GoodsModal
